var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfettiGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.44 71.482C23.338 69.41 3.273 57.78 4.376 54.95l2.984-7.014c-.742 1.588 19.224 13.52 18.14 16.29l-3.062 7.256z",
    fill: "#53BA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.391 71.539c-1.091 2.588-8.427 1.401-15.398-1.586l3.056-7.167c6.97 2.987 14.221 4.368 15.398 1.585-.006.02-2.526 5.957-3.056 7.168z",
    fill: "#65E200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.974 58.438c.9-2.071-19.16-13.699-18.056-16.53l2.978-6.995C12.154 36.5 32.116 48.43 31.03 51.2l-3.057 7.237zM35.92 39.748c2.046-4.824-7.47-23.263-5.053-28.948l2.986-7.018c-2.569 6.015 7.933 22.186 5.153 28.713l-3.086 7.253z",
    fill: "#53BA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.95 58.502c-.49 1.156-4.75.805-11.725-2.16-6.97-2.986-11.438-2.29-11.894-1.234 0 0 2.335-5.508 3.057-7.169.655-1.526 4.924-1.752 11.894 1.234 6.97 2.985 11.189 3.458 11.718 2.18-.02-.006-2.535 5.911-3.05 7.149zM36.119 39.262c-.953 2.233-5.407 3.225-13.041 2.544-7.547-.674-12.665-1.062-13.122-.006 0 0 2.336-5.509 3.037-7.177.655-1.527 5.561-.761 13.122.007 7.454.755 12.168-.487 13.035-2.525.02.007-2.502 5.946-3.031 7.157z",
    fill: "#65E200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiGreen);
export default __webpack_public_path__ + "static/media/confetti-green.c0091149.svg";
export { ForwardRef as ReactComponent };